@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../../../constants/spacing.module.less';
@import '../../../../../../../app-brand/entities/entity-layer.module.less';

.body-inputs {
  max-width: 300px;
  display: grid;
  grid-template-columns: 50% auto;
  column-gap: @space-8;
}

.loading-icon {
  height: 32px;
  width: 32px;
  margin: auto;
}

.popover-title {
  margin: 0;
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  background-color: @product-page--inventory-popover--background-color;
  border-bottom: 1px solid @product-page--inventory-popover--border-color;
  border-radius: 5px 5px 0 0;
}

.popover-body {
  padding: 9px 14px;
  display: flex;
}

.popover-buttons {
  display: flex;
  justify-content: space-between;
  padding: 0 10px 10px;
}
